import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-navy py-12 text-white" data-id="element-100" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-101" data-mp="3gh3rqfvjs8fo">
        <p className="font-display text-lg font-extrabold leading-tight text-gold sm:text-xl" data-id="element-102" data-mp="32p5lqdx4usnq">
          🇦🇷 MegaPack Caligrafía y Lectoescritura™
        </p>

        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/80" data-id="element-103" data-mp="3ufa64ckw7foy">
          El sistema de lectoescritura y caligrafía N°1 para familias y docentes de nivel
          inicial y primario en Argentina. Porque acompañar a un niño/a a aprender a leer
          y escribir no debería costarte todos los domingos del año.
        </p>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-semibold" data-id="element-104" data-mp="3qbvoxil7wt9x">
          <li data-id="element-105" data-mp="29xvqkc20tbos">
            <a href="mailto:soportenovarcursos@gmail.com" className="inline-flex items-center gap-1.5 text-celeste-light underline-offset-4 hover:underline" data-id="element-106" data-mp="2a1jjpa3jzw2z">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="3lbdcst8dy9lt" />
              soportenovarcursos@gmail.com
            </a>
          </li>
          <li className="inline-flex items-center gap-1.5 text-celeste-light" data-id="element-108" data-mp="3v7zx9gwsuynb">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-109" data-mp="3q8wphopfqebn" />
            @novarecursos
          </li>
          <li className="inline-flex items-center gap-1.5 text-celeste-light" data-id="element-110" data-mp="82idhvaq8efw">
            <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="33xbprfttmpc" />
            novarecursos.online
          </li>
        </ul>

        <div className="mt-8 space-y-1 border-t border-white/15 pt-6 text-xs text-white/55" data-id="element-112" data-mp="htd4te2ty487">
          <p data-id="element-113" data-mp="ct76jf221jh5">© MegaPack Caligrafía y Lectoescritura™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-114" data-mp="qt8f7gok9v76">Prohibida la reproducción y redistribución sin autorización expresa.</p>
        </div>

        <p className="mt-6 font-display text-base font-bold text-white/85" data-id="element-115" data-mp="ms6dmt769721">
          🇦🇷 “El próximo domingo puede ser diferente.”
        </p>
      </div>
    </footer>;
}